import { type JSX } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { SavedThemesPage } from '@/features/themes/pages/SavedThemesPage';

export const Route = createFileRoute('/banco-de-temas/salvos')({
  component: SalvosTab,
});

function SalvosTab(): JSX.Element {
  return <SavedThemesPage />;
}
